var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingFlag),expression:"loadingFlag"}],ref:"chart",staticClass:"bs-charts",attrs:{"element-loading-spinner":"el-icon-loading","element-loading-background":"#151d32"}})}
var staticRenderFns = []

export { render, staticRenderFns }